import { inject, Injectable } from '@angular/core';
import {
  AuthCredentialExchangeDto,
  AuthFlowResponseDto,
  AuthMfaCodeExchangeDto,
  AuthSessionDto,
  FlowsClient,
  MfaUrlsClient,
  SessionsClient,
} from '@unity/clients';
import { EMPTY, Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly flowsClient = inject(FlowsClient);
  private readonly mfaUrlsClient = inject(MfaUrlsClient);
  private readonly sessionsClient = inject(SessionsClient);

  /*
  Login
  */

  // Step 1: determine flow for user
  public getAuthFlow(username: string): Observable<AuthFlowResponseDto> {
    return this.flowsClient.getOne(username);
  }

  // Step 2a: start MFA flow
  public startMfaFlow(username: string, password: string): Observable<never> {
    const url = new URL('login', window.location.origin);
    url.searchParams.set('mfa_success', 'true');
    url.searchParams.set('username', username);

    return this.mfaUrlsClient
      .createOne({
        username,
        password,
        redirect_url: url.toString(),
      })
      .pipe(
        switchMap(mfaUrlResponse => {
          window.location.href = mfaUrlResponse.redirect_uri;
          return EMPTY;
        })
      );
  }

  // Step 3: Create Unity session (ie, log in)
  public createRopgSession(request: AuthCredentialExchangeDto): Observable<AuthSessionDto> {
    return this.sessionsClient.createOneRopgSession(request);
  }

  public createAcgSession(request: AuthMfaCodeExchangeDto): Observable<AuthSessionDto> {
    return this.sessionsClient.createOneAcgSession(request);
  }

  /*
  End login
  */
}
